import animation from "../orders/images/animation.gif";
import React, {useEffect, useState} from "react";
import {LinearProgress} from "@material-ui/core";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import TrackerMessage from "./TrackerMessage";

/**
 * JSS make styles.
 * @type {(props?: any) => ClassNameMap<"waitingText">}
 */
const useStyles = makeStyles((theme) => ({
    waitingText: {
        margin: "1rem 0",
        justifyContent: "center",
        textAlign: "center"
    }
}));
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({...state.invoice});

const ProgressTruck = (props) => {
    const classes = useStyles();
    const {
        bill: {
            time_to_special
        }
    } = props;

    /**
     * State to handle the progress percentage of the progress bar.
     */
    const [progress, setProgress] = useState(1);
    /**
     * State to handle the time (seconds)
     */
    const [counter, setCounter] = useState(1);
    /**
     * State to check progress has ended.
     */
    const [progressEnded, setProgressEnded] = useState(false);

    /**
     * full time (seconds)
     * @type {number}
     */
    const fullTime = time_to_special * 60;

    /**
     * one percent of the full time (seconds)
     * @type {number}
     */
    const onePercent = fullTime / 100;

    useEffect(() => {
        /**
         * interval to fire every second and handle progress.
         * @type {number}
         */
        const timer = setInterval(() => {
            setCounter(oldCounter => {
                if (oldCounter === fullTime)
                    handleProgressEnded()
                return oldCounter + 1
            })
            setProgress(oldProgress => oldProgress + (progress / onePercent))
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    /**
     * starts progress again with different message
     */
    const handleProgressEnded = () => {
        setProgress(1)
        setCounter(1)
        setProgressEnded(true)
    }

    return <>
        <img style={{width: "100%"}} alt={"loop-loading"} src={animation}/>
        <LinearProgress variant="determinate" value={progress}/>
        <Grid container className={classes.waitingText}>
            <TrackerMessage progressEnded={progressEnded}/>
        </Grid>
    </>
}

export default connect(mapStateToProps)(ProgressTruck);